import Device from '../Device';
import { hwh } from './Common';

const questions = hwh.concat([{
  type: 'gravity-pairing-code',
  name: 'pairingCode',
  model: 'pairingCode',
  label: 'step3CarinaPairingCode',
  show: (values, parent) => Boolean(parent.allQuestionsValid),
  active: true,
  mfg: 'carina',
  validation: 'required',
}]);

const addDevice = async (values, context) => null;

const carina = new Device('carina', { mfg: 'carina', questions, addDevice });

export default carina;
